module.exports = __webpack_public_path__ + "assets/0b70ff0f4e36bfb146794b28af1544f3.mp3";